export const BAUTH_TOKEN_HEADER = 'Basic YWNlcG1vYmlsZTpeMzZtUWpTWVMyWmo=';
